<template>
    <div class="gh-page gh-page--about">
        <div class="gh-page-breadcrumb">
            <gh-breadcrumb>
                <gh-breadcrumb-item to="#" :isLast="true">About Us</gh-breadcrumb-item>
            </gh-breadcrumb>
        </div>

        <div class="gh-section gh-page-intro">
            <div class="container">
                <p class="gh-section__subheading">
                    Founded in 2007, Mental Health Academy (MHA) is a leading provider of online professional development (CPD) education for mental health professionals.
                </p>
                <p class="gh-section__subheading">
                    Through our state-of-the-art learning platform, we connect you with global mental health experts and hundreds of hours of learning – all conveniently accessible online, 24/7.
                </p>
                <p class="gh-section__subheading">
                    We exist to empower people. We’d love to be part of your learning journey.
                </p>
            </div>
        </div>

        <!-- <div class="gh-section gh-page-menus">
            <div class="container">
            <el-menu :default-active="activeMenuIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item v-for="(menu, index) in menus" :key="menu.ref" :index="'' + index">
                {{ menu.label }}
            </el-menu-item>
        </el-menu>
        </div>
        </div> -->


        <section class="gh-section gh-bg-white gh-why-learn-section" id="why-learn-with-mha">
            <div class="container">
                <h1 class="gh-section__heading gh-section__heading-large gh-text-align-left">Why Learn with MHA</h1>
                <p class="gh-section__body">
                    We work closely with practitioners, researchers, industry associations and leading educational institutions globally to bring you truly world-class, relevant training. As an MHA member, you’ll enjoy unrestricted access to {{ LaraVue.figure.totalHours }}+ hours of learning and other unique benefits.
                </p>
                <el-row :gutter="40" class="gh-why-learns">
                    <el-col
                         :xs="24" :sm="12" :lg="8"
                         v-for="(learn, index) in whyLearns"
                         :key="index"
                         :class="'gh-why-learn-item ' + 'gh-why-learn-item-'+index">
                         <div class="gh-why-learn-item-inner">
                            <div :class="`gh-why-learn-icon-text gh-why-learn-icon--${index + 1}`"></div>
                             <img class="why-learn-image" :src="'/images/app/about/' + learn.img" :alt="learn.title" width="65" height="65" loading="lazy">
                            <p class="gh-why-learn-title">{{ learn.title }}</p>
                            <p class="gh-why-learn-description" v-html="learn.description"></p>
                         </div>
                    </el-col>
                </el-row>
            </div>
        </section>

        <section class="gh-section gh-learning-formats-section" id="learning-formats">
            <div class="container gh-learning-formats-container">
                <h2 class="gh-section__heading gh-section__heading-large gh-text-align-left">Learning Formats</h2>
                <p class="gh-section__body">
                    Our courses combine text and video-based content with our state-of-the-art educational platform to make your learning experience more accessible and rewarding.
                </p>
                <div class="gh-learning-formats">
                    <el-collapse v-model="activeLearningFormatsTab" accordion class="gh-learning-formats-accordion">
                        <el-collapse-item
                                v-for="learningFormat in learningFormats"
                                :key="learningFormat.id"
                                :title="learningFormat.title"
                                :name="learningFormat.id">
                            <template #title>
                                <div class="gh-tab-title">
                                    <p class="gh-tab-title-label">{{ learningFormat.title }}</p>
                                    <img v-if="activeLearningFormatsTab !== learningFormat.id" src="/images/app/about/grey-arrow.png" alt="Click to open" width="33" height="33" loading="lazy">
                                    <img v-else src="/images/app/about/blue-arrow.png" alt="Click to open" width="33" height="33" loading="lazy">
                                </div>
                            </template>
                            <div class="gh-tab-text" v-html="learningFormat.text"></div>
                        </el-collapse-item>
                    </el-collapse>

                    <div class="gh-learning-formats-active">
                        <h4 class="gh-learning-formats-title">{{ activelearningFormat.title }}</h4>
                        <div class="gh-learning-formats-intro" v-html="activelearningFormat.text"></div>
                    </div>
                </div>
            </div>
        </section>

        <section class="gh-section gh-industry-partners gh-bg-white" id="industry-partners">
            <div class="container">
                <div class="gh-industry-partners__inner">
                    <div class="gh-industry-partners__body">
                        <h2 class="gh-section__heading gh-section__heading-large gh-text-align-left">Industry Partners</h2>
                        <p class="gh-section__body">
                            We work closely with peak industry associations in Australia, Canada and the United States to ensure our programs are relevant and up-to-date with the latest research and practice standards.
                        </p>
                    </div>
                    <div class="gh-industry-partners__image">
                        <img src="https://d26heqcxf097pb.cloudfront.net/images/app/about/Industry-Partners-2024.png" alt="Industry Partners image" loading="lazy" width="460" height="238">
                    </div>
                </div>
            </div>
        </section>


        <section class="gh-section gh-our-values" id="our-values">
            <div class="container">
                <h2 class="gh-section__heading gh-section__heading-large gh-text-align-left">Our Values</h2>
                <el-row :gutter="40">
                    <el-col :sm="24" :md="8"
                        v-for="value in values" :key="value.id"
                        class="gh-our-value">
                        <p class="gh-our-value__title">{{ value.title }}</p>
                        <p class="gh-our-value__description">{{ value.description }}</p>
                        </el-col>
                </el-row>
            </div>
        </section>


        <section class="gh-section gh-more-about gh-bg-white" id="more-about-mha">
            <div class="container">
                <el-row :gutter="80" class="gh-more-about__inner">
                    <el-col :sm="24" :md="12" class="gh-more-about-col__heading">
                        <h2 class="gh-section__heading gh-section__heading-large gh-text-align-left">More About MHA</h2>
                    </el-col>
                    <el-col :sm="24" :md="12">
                        <el-row class="gh-more-about__links">
                            <el-col v-for="about in moreAbouts" :key="about.id">
                                <img src="/images/app/about/grey-arrow.png" alt="Click to open" width="33" height="33" loading="lazy">
                                <a :href="about.link" target="_blank">{{ about.title }}</a>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </section>

        <section class="gh-section gh-join-today">
            <div class="container">
                <h2 class="gh-section__heading gh-section__heading-large gh-text-center">Join our Community Today</h2>
                <p class="gh-section__body gh-text-center">
                    Thousands of your professional peers are already enjoying access to the largest and most diverse CPD catalogue in the country. Join our growing community and share our passion for creating lasting change in the world through education and altruism.
                </p>


                <div class="gh-join-today__cta">
                    <router-link to="/join" class="gh-button-redesign gh-button-redesign--primary">Join Now</router-link>
                </div>
            </div>
        </section>

        <gh-newsletter-view></gh-newsletter-view>
    </div>
</template>

<script>
    import controlItems from './controlItems';
    import learningModes from './learningModes';
    import UX from '../../../utils/ux';
    import ghTestimonialGrid from '@/modules/testimonial/components/TestimonialGrid.vue'

    export default {
        components: {
            ghTestimonialGrid
        },

        data() {
            return {
                currentControl: 0,
                moreTestimonials: false,
                activeMenuIndex: '0',
                activeLearningFormatsTab: 1,
                menus: [
                    {
                        label: 'Why Learn with MHA',
                        id: 'why-learn-with-mha'
                    },
                    {
                        label: 'Learning Formats',
                        id: 'learning-formats'
                    },
                    {
                        label: 'Industry Partners',
                        id: 'industry-partners'

                    },
                    {
                        label: 'Our Values',
                        id: 'our-values'
                    },
                    {
                        label: 'More About MHA',
                        id: 'more-about-mha'
                    }
                ],
                whyLearns: [
                    {
                        'title': 'Quality',
                        'description': `Learn the latest research and best practice in mental health from ${LaraVue.figure.totalAuthors}+ internationally-renowned, award winning authors, practitioners, researchers and educators (meet our experts <a href="/team" target="_blank">here</a>).`,
                        'img': 'about-quality.svg'
                    },
                    {
                        'title': 'Recognition',
                        'description': 'Our courses meet industry standards for professional development and are recognised by peak industry associations and registration bodies, helping you meet your CPD requirements (learn more about CPD <a href="/faqs#10" target="_blank">here</a>).',
                        'img': 'about-recognition.svg'
                    },
                    {
                        'title': 'Diversity',
                        'description': 'Access hundreds of topics, including evidence-based interventions, culturally-informed counselling, self-care strategies, therapeutic modalities, diagnostic tools, and much more (view our courses and topics <a href="/catalogue" target="_blank">here</a>).',
                        'img': 'about-diversity.svg'
                    },
                    {
                        'title': 'Affordability',
                        'description': `Pay less than $1/day (either monthly or annually) to enjoy unrestricted access to ${LaraVue.figure.totalNumberOfCourses}+ courses, online learning tools, course certificates, and much more (view our payment options <a href="/join" target="_blank">here</a>).`,
                        'img': 'about-affordability.svg'
                    },
                    {
                        'title': 'Convenience',
                        'description': 'With all courses and resources accessible in the cloud (online, 24/7), learning conveniently comes to you – wherever you are and whenever you need it the most.',
                        'img': 'about-convenience.svg'
                    },
                    {
                        'title': 'Social Impact',
                        'description': 'By learning at MHA, you’ll directly support causes that empower some of the world’s most vulnerable and underserved communities (learn more about our social impact <a href="/social-impact" target="_blank">here</a>).',
                        'img': 'about-socialimpact.svg'
                    }
                ],
                learningFormats: [
                    {
                        id: 1,
                        title: 'Text Courses',
                        text: '<p>Developed by MHA’s academic team, our text courses are referenced from textbooks, peer-reviewed articles, research journals and other reputable sources. Most MHA text courses range from 1-4 hours in duration.</p>'
                    },
                    {
                        id: 2,
                        title: 'Video Courses',
                        text: '<p>Presented by internationally-renowned experts, our video courses include webinars, conference recordings, skill demonstrations, specialised video series, and more. Most MHA video courses range from 1-3 hours in duration.</p>'
                    },
                    {
                        id: 3,
                        title: 'Course Collections',
                        text: '<p>Our academic team regularly hand-picks courses exploring a common topic, and groups them into MHA Collections. Much like a playlist, you can enrol in a Collection with a single click. MHA collections range from 5 to 100+ hours.</p>'
                    },
                    {
                        id: 4,
                        title: 'Micro-Credential Courses*',
                        text: '<p>Our Micro-Credential Courses provide a deep-dive, content-rich experience for learners. These programs are our gold standard for professional development. MHA micro-credential courses vary in duration, but usually start from 25+ hours.</p> <p class="gh-hint">*Micro-Credential courses are not included with MHA membership (i.e. they require a separate enrolment fee).</p>',
                    }
                ],

                values: [
                    {
                        id: 1,
                        title: 'Learning for life',
                        description: 'By deploying best in class training over innovative delivery platforms, we enable practitioners to continue to develop their professional capabilities over their working lifespan.'
                    },
                    {
                        id: 2,
                        title: 'Empowering learners',
                        description: 'By breaking down the traditional barriers of access and cost to world class knowledge, we empower learners to engage in and apply the most recent and efficacious mental health strategies.'
                    },
                    {
                        id: 3,
                        title: 'Rising the tide of wellbeing',
                        description: 'By providing the global mental health workforce access to world class training, we facilitate leveraged health outcomes, thereby rising the tide of wellbeing in our communities.'
                    }
                ],

                moreAbouts: [
                    {
                        id: 1,
                        title: 'Learn more about our social impact initiatives',
                        link: '/social-impact'
                    },
                    {
                        id: 2,
                        title: 'Read independent reviews by our learners',
                        link: 'https://www.productreview.com.au/p/mental-health-academy.html'
                    },
                    {
                        id: 3,
                        title: 'Explore our Frequently Asked Questions',
                        link: '/faqs'
                    }
                ]
            }
        },

        computed: {
            LaraVue() {
                return LaraVue
            },

            controlItems() {
                return controlItems.get();
            },

            activeControlItem() {
                return this.controlItems[this.currentControl];
            },

            learningModes() {
                return learningModes.get();
            },

            activelearningFormat() {
                return _.find(this.learningFormats, { id: this.activeLearningFormatsTab })
            }
        },

        methods: {
            handleSelect(index) {
                this.activeMenuIndex = '' + index

                UX.scrollTo(document.getElementById(this.menus[index].id));
            },

            updateControlImage(active) {
                if (active === '') return;

                this.currentControl = active;
            },

            scrollToSection() {
                this.$route.hash && UX.scrollTo(document.getElementById(this.$route.hash.substring(1)));
            }
        },

        watch: {
            '$route'(newRoute) {
                newRoute.hash && this.scrollToSection();
            }
        },

        mounted() {
            this.scrollToSection();
        }
    }
</script>

<style lang="scss" scoped>
    .gh-page-intro {
        padding-bottom: 1rem;
    }
    .testimonials {
        background: #f3f3f3;
    }

    .start {
        background: #fff;
    }

    html, body { -ms-overflow-style: none; overflow: auto; }

    .gh-page-menus {
        .el-menu {
            overflow-x: scroll;

        }
        .el-menu::-webkit-scrollbar {
            display: none;
        }

          -ms-overflow-style: -ms-autohiding-scrollbar;
    }

    .gh-why-learn-section {
        .gh-section__body {
            max-width: 770px;
            margin-top: 2rem;
        }

        .gh-why-learns {
            margin-top: 2rem;
            margin-bottom: -1.5rem;

            .gh-section__intro {
                margin-bottom: 1rem;
            }
            .why-learn-image {
                width: 65px;
                height: 65px;
                display: block;
                margin-bottom: 20px;

                @media (max-width: 678px) {
                    margin-bottom:10px;
                }

            }
            .gh-why-learn-item {
                margin: 1rem 0;
                .gh-why-learn-item-inner {
                    padding: 0rem 10px 0 10px;
                    .gh-why-learn-title {
                        color: #003d78;
                        padding-bottom: .5rem;
                        line-height: 1;
                        font-size: 1.3rem;
                        font-weight: 600;
                    }

                    .gh-why-learn-description {
                        font-weight: 600;
                        transition: .3s;
                        font-size: 1.05rem;
                    }
                }
            }
        }
    }

    .gh-learning-formats-section {
        background: #F9F9F9;
        .gh-section__body {
            margin-top: 1.5rem;
            margin-bottom: 2rem;
        }

        .gh-learning-formats-active {
            display: none;
        }

        .gh-learning-formats-accordion {
                .el-collapse-item {
                    border-bottom: solid 1px #DDDDDD;
                    .gh-tab-title {
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                        align-items: center;
                        padding-left: 1rem;
                        padding-right: 1rem;

                        img {
                            width: 33px;
                            height: 33px;
                        }
                    }
                }
            }
    }

    .gh-more-about {
        .gh-more-about-col__heading {
            justify-content: flex-start;
            align-items: center;
            display: flex;
            margin-top: 0;
        }
        .gh-section__heading {
            color: #085078;
            font-size: 2.2rem;
            margin-bottom: 2rem;
        }

        .gh-more-about__inner {
            margin-right: 0 !important;
        }
        .gh-more-about__links {
            .el-col {
                display: flex;
                align-items: center;
            }
            img {
                width: 33px;
                height: 33px;
            }
            a {
                font-size: 1.25rem;
                color: #085078;
                padding: 1rem;
                margin-left: 1rem;
            }
        }
    }

    .gh-industry-partners {
        .gh-section__heading {
            color: #085078;
        }

        .gh-industry-partners__body {
            background: #CEEFEB;
            padding: 2rem;
            color: #085078;
            border-radius: 5px;
            box-shadow: 0px 0px 10px 2px rgba(237,238,239,0.97);
            z-index: 1;

            .gh-section__body {
                font-weight: 600;
                margin-top: 2rem;
            }
        }

        .gh-industry-partners__image {
            margin-top: 2rem;
            border-radius: 5px;
            padding: 1rem;
            box-shadow: 0px 0px 10px 2px rgba(234,235,236,0.93);
            z-index: 0;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .gh-join-today {
        .gh-section__heading {
            font-size: 2.2rem;
        }
        .gh-section__body {
            margin: auto;
            margin-top: 2rem;
        }
        .gh-join-today__cta {
            margin-top: 3.5rem;
            text-align: center;
            .gh-button-redesign--primary {
                border-color: #085078;
            }

            .gh-button-redesign {
                color: #085078;
            }

        }
    }

    .gh-our-values {
        .gh-our-value {
            &__title {
                color: #085078;
                font-size: 1.7rem;
                font-weight: 600;
                margin-top: 1rem;
                margin-bottom: 1rem;
            }

            &__description {
                color: #87abbd;
                font-size: 1.25rem;
                line-height: 1.4;;
            }
        }
    }

    @media only screen and (min-width: 768px){
        .gh-more-about {
            .gh-more-about__inner {
                margin-right: -40px !important;
            }
        }
        .gh-why-learn-section {
            padding-bottom: 1rem;
            .gh-why-learns {
                .gh-why-learn-item {
                    .gh-why-learn-item-inner {
                        .gh-why-learn-description {
                            min-height: 160px;
                        }
                    }
                }
            }
        }
    }

    @media only screen and (min-width: 992px){
        .gh-more-about {
            .gh-section__heading {
                margin-bottom: 0;
            }
            .gh-more-about-col__heading {
                padding: 6.5rem 2rem 6.5rem 20px;
                justify-content: flex-end;
                border-right: solid 1px #DDDDDD;
            }
        }

        .gh-why-learn-section {
            padding-bottom: 1.5rem;
            .gh-why-learns {
                .gh-why-learn-item {
                    .gh-why-learn-item-inner {
                        .gh-why-learn-description {
                            min-height: 140px;
                        }
                    }
                }
            }
        }
    }

    @media screen and (min-width: 1024px) {
        .gh-more-about {
            .gh-more-about-col__heading {
                padding: 6rem 2rem 5.5rem 20px;
            }
        }

        .gh-learning-formats-section {
            .gh-learning-formats-container {
                .gh-heading {
                    margin-bottom: 1rem;
                    text-align: center;
                    font-size: 36px;
                }
            }

            .gh-learning-formats {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
            }

            .gh-learning-formats-accordion {
                width: 34%;
                max-width: 500px;
                flex-shrink: 0;
                margin-right: 6rem;
                border: none;
            }

            .gh-learning-formats-active {
                display: block;
                padding-top: 1rem;
            }

            .gh-learning-formats-module {
                font-size: 20px;
                margin-bottom: 1rem;
                font-weight: 600;
                color: #92A8B3;
            }

            .gh-learning-formats-title {
                margin-bottom: 2rem;
                color: #085078;
                font-size: 1.7rem;
            }
        }

        .gh-industry-partners {
            .gh-industry-partners__image {
                padding: 5rem;
            }
        }
    }

    @media screen and (min-width: 1200px){
        .gh-more-about {
            .gh-more-about-col__heading {
                padding: 4rem 2rem 4rem 20px;
            }
        }

        .gh-industry-partners {
            .gh-industry-partners__body {
                max-width: 526px;
                padding: 3rem 4.5rem;
            }
            .gh-industry-partners__inner {
                position: relative;
                height: 357px;
                align-items: center;
                display: flex;
            }
            .gh-industry-partners__image {
                margin-top: 0;
                position: absolute;
                padding: 3rem 4rem;
                top: 0;
                right: 1rem;
                max-width: 700px;
                height: 356px;
                img {
                    padding-left: 8rem;
                }
            }
        }
    }
</style>

<style lang="scss">
    .gh-why-learn-section {
        .gh-why-learn-description {
            a {
                font-family: freight-sans-pro, sans-serif;
            }
        }
    }
    .gh-learning-formats-section {
        .gh-learning-formats-container {
            .el-collapse-item__header {
                background: inherit;
                height: auto;
                 .gh-tab-title-label {
                        font-size: 1.4rem;
                        padding: 1rem 0;
                    }
            }

            .el-collapse-item__arrow {
                display: none;
            }

            .el-collapse-item__content {
                .gh-tab-text p {
                    font-size: 1.25rem;
                    font-weight: 600;
                    color: #343841;
                    padding: 1rem;
                }
            }

            .el-collapse-item {
                .gh-tab-title-label {
                    color: #92A8B3;
                }
                &.is-active {
                    .gh-tab-title-label {
                        color: #085078;
                        font-weight: 600;
                    }
                }
            }
            .gh-learning-formats-intro {
                p {
                    font-size: 1.25rem;
                    font-weight: 600;
                    color: #343841;
                    + p {
                        margin-top: 1rem;
                    }
                }
                .gh-hint {
                    font-size: 1rem;
                    color: #5D6067;
                }
            }
        }
    }

    @media screen and (min-width: 1024px) {
        .gh-learning-formats-section {
            .gh-learning-formats-container {
                .el-collapse-item__wrap {
                    display: none;
                }

                .el-collapse-item__header {
                    &.is-active {
                        .el-collapse-item__arrow {
                            transform: none !important;
                        }
                    }
                }
            }
        }
    }
</style>
